import {
  SYSTEM_SUBMIT_POSITION_NAME_TYPE_BEGIN,
  SYSTEM_SUBMIT_POSITION_NAME_TYPE_SUCCESS,
  SYSTEM_SUBMIT_POSITION_NAME_TYPE_FAILURE,
  SYSTEM_SUBMIT_POSITION_NAME_TYPE_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function submitPositionNameType(params) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: SYSTEM_SUBMIT_POSITION_NAME_TYPE_BEGIN,
    });
      let apiurl = '/api/b/positionType/add';

      if (params.id != undefined){
          apiurl = '/api/b/positionType/update';
      }

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
      const promise = new Promise((resolve, reject) => {
          request({
              method:'post',
              url:apiurl,
              data: params,
          }).then( data => {
              dispatch({
                  type: SYSTEM_SUBMIT_POSITION_NAME_TYPE_SUCCESS,
                  data: data,
              });
              resolve(data);
          }).catch (error => {
              dispatch({
                  type: SYSTEM_SUBMIT_POSITION_NAME_TYPE_FAILURE,
                  data: { error: error },
              });
              reject(error);
          })
      });
      return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissSubmitPositionNameTypeError() {
  return {
    type: SYSTEM_SUBMIT_POSITION_NAME_TYPE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SYSTEM_SUBMIT_POSITION_NAME_TYPE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        submitPositionNameTypePending: true,
        submitPositionNameTypeError: null,
      };

    case SYSTEM_SUBMIT_POSITION_NAME_TYPE_SUCCESS:
      // The request is success
      return {
        ...state,
        submitPositionNameTypePending: false,
        submitPositionNameTypeError: null,
      };

    case SYSTEM_SUBMIT_POSITION_NAME_TYPE_FAILURE:
      // The request is failed
      return {
        ...state,
        submitPositionNameTypePending: false,
        submitPositionNameTypeError: action.data.error,
      };

    case SYSTEM_SUBMIT_POSITION_NAME_TYPE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        submitPositionNameTypeError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/system/redux/submitPositionNameType.js